import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  StyleSheet,
  PixelRatio,
  Dimensions,
  Platform,
  ActivityIndicator,
  Modal,
  ScrollView,
  TextInput,
  Pressable,
} from "react-native";
import { Image } from "expo-image";
import { MaterialCommunityIcons, Ionicons } from "@expo/vector-icons";
import * as Google from "expo-auth-session/providers/google";
import Colours from "../../utils/Colours"; // Adjust path based on your utilities file setup
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import AppleSignin from "react-apple-signin-auth";
import {
  useNavigation,
  useRoute,
  useIsFocused,
  useNavigationContainerRef,
} from "@react-navigation/native";
import axios, { axiosWithCredentials } from "../../api/axios";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import AppContext from "../../context/AppContext";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import * as AuthSession from "expo-auth-session";
import { SafeAreaView } from "react-native-safe-area-context";
import DoingsModeBadge from "../../icons/DoingsModeBadge";
import { useQuery } from "@tanstack/react-query";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// --- DUMMY MENU DATA ---
const MOCK_CATEGORIES = ["All", "Drinks", "Mains", "Sides"];
const MOCK_MENU_ITEMS = [
  {
    id: "m1",
    name: "Asun (Spicy Roasted Goat)",
    category: "Mains",
    price: 7500,
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=300",
  },
  {
    id: "m2",
    name: "Jollof Rice & Grilled Chicken",
    category: "Mains",
    price: 8500,
    image: "https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?w=300",
  },
  {
    id: "m3",
    name: "Hennessy VSOP (Glass)",
    category: "Drinks",
    price: 12000,
    image: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=300",
  },
  {
    id: "m4",
    name: "Cold Heineken Lager",
    category: "Drinks",
    price: 3500,
    image: "https://images.unsplash.com/photo-1608270176050-1b7758210f8d?w=300",
  },
  {
    id: "m5",
    name: "Spicy Peppered Gizzard",
    category: "Sides",
    price: 5000,
    image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=300",
  },
];

const BrandMenuScreen = () => {
  const { setAuth, setActivitySettings, setUserInfo, isLoggedIn, auth } = useContext(AppContext);
  const { sub, email, phoneNumber } = useAuth();
  const isFocused = useIsFocused();
  const [allMenuItems, setAllMenuItems] = useState([]);
  const [activeShowData, setActiveShowData] = useState(null);
  const [isOngoingShow, setIsOngoingShow] = useState(false);

  const [selectedWaiter, setSelectedWaiter] = useState(null);

  const [selectedPaymentType, setSelectedPaymentType] = useState("now");
  const [showSelectWaiter, setShowSelectWaiter] = useState(false);

  const navigation = useNavigation();
  const route = useRoute();
  const axiosPrivate = useAxiosPrivate();

  // 1. Read individual primitive identifiers directly from the URL route safely
  const tableId = route.params?.tableId;
  const isTopUp = route.params?.isTopUp;

  // const { isTopUp } = route.params || {};
  // const currentTier = route.params?.flexTier || "regular";
  const initialTier = route.params?.flexTier || "regular";

  const tableAnonymity = route.params?.tableAnonymity || false;

  // console.log("tableANONYMITY", tableAnonymity);

  const [selectedPaymentChoice, setSelectedPaymentChoice] = useState(null); // 'NOW' or 'LATER'

  const [publicCategories, setPublicCategories] = useState(["All"]);

  const [tableDataUpdate, setTableDataUpdate] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const [isCartExpanded, setIsCartExpanded] = useState(false);
  const [isProcessOrderLoading, setIsProcessOrderLoading] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [brandMeta, setBrandMeta] = useState(null); // Local state container for company styling
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [cart, setCart] = useState({}); // Shape: { [item._id]: quantity }
  //   const [isLoadingMenue, setIsLoadingMenue] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAuthLoading, setIsAuthLoading] = useState(false);

  // Auth verification state controls
  const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);

  // 2. Interactive Flex Tier State
  const [selectedFlexTier, setSelectedFlexTier] = useState(initialTier);

  console.log("selectedFlexTier", selectedFlexTier);

  const [showChoosePayment, setShowChoosePayment] = useState(false);

  // const userHasValidCredentials = !!(user?.email || user?.phoneNumber);
  // const userHasValidCredentials = !!email;
  const userHasValidCredentials = !!(email || phoneNumber);

  const shouldAutoOrder = useRef(false);
  const navigationRef = useNavigationContainerRef();

  // Then on focus, check the ref

  useEffect(() => {
    //console.log("mdhdyyd");
    if (!isFocused) return;
    if (!shouldAutoOrder.current) return;
    //console.log("hersbgs");

    // if (Object.keys(cart).length === 0) {
    //   shouldAutoOrder.current = false;
    //   return;
    // }

    // //console.log("auto order triggered - cart:", cart, "tableId:", tableId);
    shouldAutoOrder.current = false; // reset immediately
    console.log("Here noe neo");
    executeOrderProcessingPipeline();

    // const isNewTable = !tableDataUpdate?.orders || tableDataUpdate.orders.length === 0;

    // if (isNewTable) {
    //   // Redirect new tables to select their baseline payment profile structure
    //   setShowChoosePayment(true);
    // } else {
    //   executeOrderProcessingPipeline();
    // }
  }, [isFocused]);

  useEffect(() => {
    console.log("tableDataWaiter", tableDataUpdate);
    console.log("waiterId", tableDataUpdate?.waiterID);
  }, [tableDataUpdate]);

  useEffect(() => {
    if (!tableId) return;

    const fetchScreenRequirements = async () => {
      try {
        setIsLoading(true);

        // Step 1: Fetch the table context details
        const tableResponse = await axios.get(`/tableDetailsPublic/tableDetailsPublic/${tableId}`);
        const tableData = tableResponse.data.tableData;

        setTableDataUpdate(tableData);
        setBrandMeta(tableData?.associatedBrand);

        const brandId = tableData?.associatedBrand?._id || tableData?.associatedBrand;

        if (brandId) {
          // Step 2: Request menu items for the host venue brand
          // Backend auto-checks if an active promoter show is currently live!
          const menuResponse = await axios.get("/getMenuItemsPublic/getMenuItemsPublic", {
            params: {
              associatedBrand: brandId,
            },
          });

          // Save active show metadata to state if present
          if (menuResponse.data?.hasActiveShow) {
            setActiveShowData(menuResponse.data.showData);
            setIsOngoingShow(true);
          } else {
            setActiveShowData(null);
          }

          // Step 3: Extract items correctly from response
          let serverItems = menuResponse.data?.data || [];
          serverItems = serverItems.filter((item) => item.isAvailable !== false);

          // Calculate item ordering based on table history
          if (Array.isArray(tableData?.orders || [])) {
            const preferenceMap = {};

            tableData.orders.forEach((batch) => {
              if (Array.isArray(batch.items)) {
                batch.items.forEach((orderedItem) => {
                  const itemIdStr = orderedItem.menuItemId?._id || orderedItem.menuItemId;
                  if (itemIdStr) {
                    preferenceMap[itemIdStr.toString()] =
                      (preferenceMap[itemIdStr.toString()] || 0) + (orderedItem.quantity || 1);
                  }
                });
              }
            });

            serverItems.sort((a, b) => {
              const idA = (a._id || a.id)?.toString();
              const idB = (b._id || b.id)?.toString();
              const countA = preferenceMap[idA] || 0;
              const countB = preferenceMap[idB] || 0;
              return countB - countA;
            });
          }

          // Hydrate React state
          setAllMenuItems(serverItems);
          setMenuItems(serverItems);

          if (serverItems.length > 0) {
            const extractedCategories = [
              "All",
              ...new Set(serverItems.map((item) => item.category).filter(Boolean)),
            ];
            setPublicCategories(extractedCategories);
          }
        }
      } catch (error) {
        console.error("PWA reload hydration breakdown:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchScreenRequirements();
  }, [tableId]);

  const brandID = brandMeta?._id;
  console.log("brandMeta", brandMeta);
  console.log("brandIDDdd", brandID);

  // Fetch waiters list for this brand
  const { data: brandWaiters = [], isLoading: isLoadingWaiters } = useQuery({
    queryKey: ["brandWaiters", brandID],
    queryFn: async () => {
      // 1. Properly await the response and assign it to `res`
      const res = await axios.get(`/getWaitersByBrand/getWaitersByBrand/${brandID}`);

      // 2. Safely extract the array from `res.data.data`
      return Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
          ? res.data
          : [];
    },
    enabled: !!brandID && showSelectWaiter,
  });

  useEffect(() => {
    if (route.params?.isTopUp === true) {
      // TopUp button was explicitly clicked -> persist to sessionStorage
      sessionStorage.setItem("is_topup_flow", "true");
    } else if (route.params?.isTopUp === false) {
      // Explicit regular navigation -> clear flag
      sessionStorage.removeItem("is_topup_flow");
    }
    // NOTE: If route.params?.isTopUp is undefined (e.g. user reloaded),
    // sessionStorage remains untouched, preserving the active session state!
  }, [route.params?.isTopUp]);

  useEffect(() => {
    if (selectedCategory === "All") {
      setMenuItems(allMenuItems);
    } else {
      // Perform an instant local client filter without hitting the server
      const filtered = allMenuItems.filter((item) => item.category === selectedCategory);
      setMenuItems(filtered);
    }
  }, [selectedCategory, allMenuItems]);

  // 1. Remove any spaces or leading zeros for an accurate baseline length assessment
  const plainInput = whatsappNumber.trim().replace(/^0+/, "");

  // 2. 🌟 NEW: Check if the string consists STRICTLY of digits (no letters or symbols allowed)
  const containsOnlyDigits = /^\d+$/.test(plainInput);

  // 3. The button activates ONLY if it's pure numbers AND hits the 10-digit mark
  const isPhoneInputReady = containsOnlyDigits && plainInput.length === 10;

  const hasTypoError = whatsappNumber.length > 0 && !/^\d+$/.test(whatsappNumber.trim());

  const handleNumberFormat = () => {
    let finalPhoneNumber = "";

    // 1. Remove everything that isn't a number
    let cleaned = whatsappNumber.replace(/\D/g, "");

    // 2. Remove any leading zeros
    cleaned = cleaned.replace(/^0+/, "");

    // 3. Strip international prefix code if appended early
    if (cleaned.startsWith("234")) {
      cleaned = cleaned.slice(3);
    }

    // 4. Double check leading zero edge cases
    cleaned = cleaned.replace(/^0+/, "");

    // Strict validation for national number length requirement
    if (cleaned.length !== 10) {
      setErrorMessage("You might have entered an invalid phone number.");
      setIsErrorCompVisible(true);
      return null; // 🌟 Return null if validation fails
    }

    finalPhoneNumber = `234${cleaned}`;

    // 🌟 Update your component state so the UI displays the polished formatting
    setWhatsappNumber(finalPhoneNumber);

    // 🌟 Return the actual string value so your submit pipeline can grab it instantly
    return finalPhoneNumber;
  };

  // --- 5. DYNAMIC PRICE RESOLUTION & TOTAL CALCULATIONS ---
  // const { totalItems, totalPrice } = useMemo(() => {
  //   return menuItems.reduce(
  //     (acc, item) => {
  //       const currentId = item._id || item.id;
  //       const qty = cart[currentId] || 0;

  //       // RESOLVE TIER PRICE: Select correct schema field dynamically
  //       const resolvedUnitPrice = currentTier === "doings" ? item.doingsPrice : item.regularPrice;

  //       return {
  //         totalItems: acc.totalItems + qty,
  //         totalPrice: acc.totalPrice + qty * (resolvedUnitPrice || 0),
  //       };
  //     },
  //     { totalItems: 0, totalPrice: 0 },
  //   );
  // }, [cart, menuItems, currentTier]);

  // 3. Dynamic Price Resolution & Total Calculations (Bound to local state)
  const { totalItems, totalPrice } = useMemo(() => {
    return menuItems.reduce(
      (acc, item) => {
        const currentId = item._id || item.id;
        const qty = cart[currentId] || 0;

        // Dynamic price selection based on active local tab state
        const resolvedUnitPrice =
          selectedFlexTier === "doings" ? item.doingsPrice : item.regularPrice;

        return {
          totalItems: acc.totalItems + qty,
          totalPrice: acc.totalPrice + qty * (resolvedUnitPrice || 0),
        };
      },
      { totalItems: 0, totalPrice: 0 },
    );
  }, [cart, menuItems, selectedFlexTier]);

  const [request, response, promptAsync] = Google.useAuthRequest({
    // 1. For Expo Go or Web testing
    // webClientId: "607742650924-4qvotvu1q75g3a9dchind088c87pmpco.apps.googleusercontent.com",
    webClientId: "607742650924-2ei9go2bl635sl9gh1pakdj2rqr3s0kn.apps.googleusercontent.com",

    // 2. For your physical iPhone build
    iosClientId: "607742650924-mbcms1rms9i91dj5l9cdp4143lgua83c.apps.googleusercontent.com",

    // 3. For your Android build
    androidClientId: "607742650924-k779l559pl0hjfse5a2kch7cqh5j71jf.apps.googleusercontent.com",

    // redirectUri: Platform.OS === "web" ? "https://app.getmeeza.com" : undefined,
    // redirectUri: Platform.OS === "web" ? "http://localhost:8081/" : undefined,
    redirectUri: AuthSession.makeRedirectUri({
      scheme: "http",
      // host: '127.0.0.1', // Swap from localhost to loopback IP
      host: "localhost", //  Swap from localhost to loopback IP
      port: 8081,
      path: "", // Explicitly forces NO trailing slash
    }),
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { authentication } = response;
      const { accessToken } = authentication;

      executeGoogleOrderProcessingPipeline(accessToken);
    }
  }, [response]);

  // 3. Fallback layout indicators to protect UI during cold starts
  if (isLoading || isAuthLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }
  // Reused brand UI layout fallback fields
  const brandName = brandMeta?.brandName || "The Venue";
  const brandAddress = brandMeta?.brandAddress || "Location Details Not Set";
  const brandImage = brandMeta?.image || "https://placehold.co/150";

  // 2. Component Core Operational State Engines
  //   const [menuItems, setMenuItems] = useState([]); // Database items replace array

  // --- 4. CART QUANTITY MANAGEMENT ENGINE ---
  const handleUpdateQuantity = (itemId, action) => {
    setCart((prevCart) => {
      const currentQty = prevCart[itemId] || 0;
      const nextCart = { ...prevCart };

      if (action === "add") {
        nextCart[itemId] = currentQty + 1;
      } else if (action === "subtract" && currentQty > 0) {
        nextCart[itemId] = currentQty - 1;
        if (nextCart[itemId] === 0) delete nextCart[itemId];
      }
      return nextCart;
    });
  };

  const handleBackNavigation = () => {
    // const isLoggedIn = !!userToken; // Check if user has a token
    const loggedIn = !!sub; // If 'sub' exists, they have a valid access token in memory
    const isWeb = Platform.OS === "web";

    console.log("SUB", sub);

    if (isWeb && !loggedIn) {
      navigation.navigate("getStarted");
    } else if (loggedIn && auth?.isProfileComplete === true) {
      navigation.navigate("main");
    } else {
      // Token exists but profile/order isn't complete yet — main isn't mounted.
      // Fall back to something that's guaranteed to exist in this state.
      navigation.goBack();
    }
  };

  // const handlePlaceOrder = () => {
  //   // 🔐 VALIDATION SECURITY CHECK
  //   //console.log("phone email", email, phoneNumber);
  //   // if (!userHasValidCredentials) {
  //   //   // Drop anchor! Show authentication option sheet before placing order items
  //   //   setIsAuthModalVisible(true);
  //   //   return;
  //   // }

  //   // NEW TABLE CHECK: Inspect order history array length
  //   // (Safely checks if tableData exists and if it has 0 orders)
  //   const isNewTable = !tableDataUpdate?.orders || tableDataUpdate.orders.length === 0;

  //   if (isNewTable) {
  //     // Redirect new tables to select their baseline payment profile structure
  //     setShowChoosePayment(true);
  //   } else {
  //     // Proceed directly to order parsing for tables with active history
  //     executeOrderProcessingPrivatePipeline();//new orders
  //   }
  // };

  const handlePlaceOrder1 = () => {
    // 1. Check if this is a brand new table session with no orders
    const isNewTable = !tableDataUpdate?.orders || tableDataUpdate.orders.length === 0;

    if (isNewTable) {
      // FORCE CHOICE: Open the payment selection overlay first, regardless of auth status
      setShowChoosePayment(true);
    } else {
      // It's an active table session! Now check credentials before appending orders
      if (!userHasValidCredentials) {
        setIsAuthModalVisible(true);
        return;
      }

      // User is authenticated and it's an existing table -> Table TopUp
      executeOrderProcessingPprivatePipeline();
    }
  };
  const handlePlaceOrder2 = () => {
    // const checkTopUp = isTopUp || sessionStorage.getItem("is_topup_flow") === "true";
    // console.log("checkTopUpppp", checkTopUp);

    // 1. Convert route param safely to boolean
    const isRouteTopUp = route.params?.isTopUp === true || route.params?.isTopUp === "true";

    // 2. Check session storage explicitly
    const isSessionTopUp = sessionStorage.getItem("is_topup_flow") === "true";

    // 3. Combine both explicitly
    const checkTopUp = isRouteTopUp || isSessionTopUp;

    console.log("DEBUG TOP-UP CHECK:", {
      isRouteTopUp,
      isSessionTopUp,
      finalCheckTopUp: checkTopUp,
    });
    if (!userHasValidCredentials) {
      setIsAuthModalVisible(true);
      return;
    } else if (checkTopUp) {
      //setShowChoosePayment(true);
      executeOrderProcessingPrivatePipelineTopUp();
      console.log("I am in Top up");
    } else {
      //New Table while logged in
      executeOrderProcessingPrivatePipeline();
    }
  };

  const handlePlaceOrder = () => {
    // 1. Convert route param safely to boolean
    const isRouteTopUp = route.params?.isTopUp === true || route.params?.isTopUp === "true";

    // 2. Check session storage explicitly
    const isSessionTopUp = sessionStorage.getItem("is_topup_flow") === "true";

    // 3. Combine both explicitly
    const checkTopUp = isRouteTopUp || isSessionTopUp;

    // Resolve active waiterID from table state first, then chosen state, then route params
    const activeWaiterID =
      tableDataUpdate?.waiterID || selectedWaiter?._id || route.params?.waiterID;

    // If no waiter is attached to this table session or manually selected, prompt user
    if (!activeWaiterID) {
      setShowSelectWaiter(true);
      return;
    }

    console.log("DEBUG TOP-UP CHECK:", {
      isRouteTopUp,
      isSessionTopUp,
      finalCheckTopUp: checkTopUp,
    });

    /** We just changed this - dont need to check authentications first, just place order*/
    // if (!userHasValidCredentials) {
    //   setIsAuthModalVisible(true);
    //   return;
    // }

    // If authenticated, show the payment choice modal instead of running pipelines directly
    setShowChoosePayment(true);
  };

  // 2. Waiter Selection Handler
  const handleSelectWaiter = (waiter) => {
    setSelectedWaiter(waiter);

    // Update table session state locally if needed
    if (setTableDataUpdate) {
      setTableDataUpdate((prev) => ({
        ...prev,
        waiterID: waiter._id,
      }));
    }

    setShowSelectWaiter(false);

    // Smooth transition directly into payment modal
    setTimeout(() => {
      setShowChoosePayment(true);
    }, 250);
  };

  // // Handle the user's selection from the "Pay now" / "Pay later" modal
  // const handlePaymentChoice = (paymentType) => {
  //   setSelectedPaymentType(paymentType);
  //   setShowChoosePayment(false);

  //   // Re-verify top-up status to ensure correct pipeline execution
  //   const isRouteTopUp = route.params?.isTopUp === true || route.params?.isTopUp === "true";
  //   const isSessionTopUp = sessionStorage.getItem("is_topup_flow") === "true";
  //   const checkTopUp = isRouteTopUp || isSessionTopUp;

  //   console.log("Payment Choice Selected:", paymentType);

  //   if (checkTopUp) {
  //     executeOrderProcessingPrivatePipelineTopUp(paymentType);
  //     console.log("I am in Top up");
  //   } else {
  //     // New Table while logged in
  //     executeOrderProcessingPrivatePipeline(paymentType);
  //   }

  //   // If the user chose "Pay Later", navigate them back to the home page immediately upon success
  //   if (paymentType === "later") {
  //     // Ensure you have access to navigation via useNavigation() hook in this component
  //     navigation.reset({
  //       index: 0,
  //       routes: [{ name: "main" }],
  //     });
  //   }
  // };

  const handlePaymentChoice = async (paymentType) => {
    setSelectedPaymentType(paymentType);
    setShowChoosePayment(false);

    console.log("Payment Choice Selected:", paymentType);

    // Call the single unified pipeline
    // const success = await executeOrderProcessingPrivatePipeline(paymentType);
    const success = await executeOrderProcessingPPipeline(paymentType);

    // If the order succeeded AND they chose "Pay Later", navigate back to main safely
    if (success && paymentType === "later") {
      navigation.reset({
        index: 0,
        routes: [{ name: "main" }],
      });
    }
  };

  /***IN USE GENERALLY IN THIS NEW MODEL - FOR PAY NOW - NO PAY LATER - TOPUP PAYMENT */
  async function executeOrderProcessingPPipeline(paymentType) {
    if (isProcessOrderLoading) return false;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return false;
    }

    try {
      setIsProcessOrderLoading(true);

      // const isLoggedIn = !!sub

      // const authResponse = await axiosWithCredentials.post("/autoCreateGuest/autoCreateGuest");

      // // const { accessToken } = authResponse.data;
      // const strictLocalToken = authResponse.data.accessToken;
      // const guestUser = authResponse.data.user;

      // 2. Check if the user is already logged in (sub exists and user is not a guest)
      const isLoggedIn = !!sub;

      let strictLocalToken = auth?.accessToken;
      let currentUser;

      if (isLoggedIn) {
        console.log("Logged-in user detected. Skipping auto-guest creation.");
      } else {
        console.log("Guest or unauthenticated user detected. Initializing guest session...");

        const authResponse = await axiosWithCredentials.post("/autoCreateGuest/autoCreateGuest");

        strictLocalToken = authResponse.data.accessToken;
        currentUser = authResponse.data.user;
      }

      // Determine top-up status from route params or session storage
      const isRouteTopUp = route.params?.isTopUp === true || route.params?.isTopUp === "true";
      const isSessionTopUp = sessionStorage.getItem("is_topup_flow") === "true";
      const isTopUp = isRouteTopUp || isSessionTopUp;

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        // const targetPrice =
        //   currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;
        const targetPrice =
          selectedFlexTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: selectedFlexTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log(
        "Calculated Order Total Amount:",
        paymentAmount,
        "| Payment Type:",
        paymentType,
        "| Is Top-Up:",
        isTopUp,
      );

      // STEP 3: Request the checkout intent payload token link from the backend
      // const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout", {
      const checkoutSetup = await axiosWithCredentials.post(
        "/payments2/initialize-checkout",
        {
          tableId,
          showId: activeShowData?._id,
          items: finalOrderItems,
          waiterId: tableDataUpdate?.waiterID,
          tableAnonymity,
          phoneNumber: whatsappNumber,
          paymentType,
          isTopUp, // <--- Crucial: Passes the flag to your unified backend
        },
        {
          headers: { Authorization: `Bearer ${strictLocalToken}` },
        },
      );

      sessionStorage.removeItem("is_topup_flow");

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally
        setAuth((prev) => ({
          ...prev,
          accessToken: strictLocalToken,
          isProfileComplete: true,
          // Check currentUser first; if undefined, preserve existing prev state or default
          isGuest: currentUser ? (currentUser.isGuest ?? false) : (prev.isGuest ?? false),
          email: currentUser?.email || prev.email,
          phoneNumber: currentUser?.phoneNumber || prev.phoneNumber,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
          reference: checkoutSetup.data?.data?.reference,
        }));
        // setAuth((prev) => ({
        //   ...prev,
        //   accessToken: strictLocalToken,
        //   isProfileComplete: true,
        //   isGuest: guestUser?.isGuest ?? true,
        //   email: guestUser?.email ?? prev.email,
        //   phoneNumber: guestUser?.phoneNumber ?? prev.phoneNumber,
        //   hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
        //   pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        //   reference: checkoutSetup.data?.data?.reference,
        // }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});
        return true; // Return true to signal success
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
        return false;
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
      return false;
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  //For new Tables
  const processPostPaymentSelection = (choice) => {
    // A. Close the selection screen
    setShowChoosePayment(false);

    // B. Save what they clicked in case we need to show the Auth Modal
    setSelectedPaymentChoice(choice);

    // C. VALIDATION SECURITY CHECK
    if (!userHasValidCredentials) {
      // Drop anchor! If they aren't logged in, intercept and show auth sheet
      setIsAuthModalVisible(true);
      return;
    }

    // D. User is logged in! Run the correct pipeline based on their account type
    if (sub) {
      console.log("PRIVIIVIV");
      executeOrderProcessingPrivatePipeline(); //- used for TopUps
    } else {
      console.log("hsnhhHHHH");

      executeOrderProcessingPipeline();
    }
  };

  const handleAppleSuccess = async (response) => {
    // Apple returns:
    // response.authorization.id_token
    // response.user (ONLY sent on the FIRST login)

    const appleCredential = {
      identityToken: response.authorization?.id_token,
      user: response.user || null,
    };

    console.log("appleCredential", appleCredential);

    // Pass it directly to your pipeline function
    await executeAppleOrderProcessingPipeline(appleCredential);
  };

  const handleAppleFailure = (error) => {
    console.error("Apple Sign-In Error:", error);
    setErrorMessage("Apple Sign-In Error");
    setIsErrorCompVisible(true);
  };

  //Mostly for Google Users--- Revisit
  // async function executeGoogleOrderProcessingPipeline(googleAuthToken) {
  //   if (isProcessOrderLoading) return;

  //   // 1. Structural safety validation
  //   if (!tableId || Object.keys(cart).length === 0) {
  //     setErrorMessage("Your cart is empty or the table context is missing.");
  //     setIsErrorCompVisible(true);
  //     return;
  //   }

  //   if (!googleAuthToken) {
  //     setErrorMessage("Google authorization token missing. Please sign in again.");
  //     setIsErrorCompVisible(true);
  //     return;
  //   }

  //   try {
  //     setIsProcessOrderLoading(true);

  //     // 2. Map items perfectly to match the backend embedded sub-document array rules
  //     const finalOrderItems = Object.keys(cart).map((cartId) => {
  //       const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
  //       const targetPrice =
  //         currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

  //       return {
  //         menuItemId: cartId, // Maps to schema menuItemId
  //         name: findItem?.name || "Unknown Item",
  //         quantity: cart[cartId],
  //         unitPrice: targetPrice || 0,
  //         totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
  //         menuType: currentTier, // ENUM: "regular" or "doings"
  //       };
  //     });

  //     // 3. Send network request to append the order to the virtual table via your Google route
  //     const response = await axiosWithCredentials.post(
  //       `/googleGuestAuth/googleGuestAuth/${tableId}`,
  //       {
  //         googleToken: googleAuthToken, // Send your token string
  //         items: finalOrderItems, // Send your mapped cart array payload
  //         tableAnonymity,
  //       },
  //     );

  //     // 4. HANDLE SUCCESSFUL SEED INGESTION
  //     if (response.status === 200 || response.status === 201) {
  //       const { accessToken } = response.data;

  //       // Unlocks the AppNav routing gateway layout context trees instantly!
  //       setAuth({
  //         accessToken,
  //         isProfileComplete: true,
  //       });

  //       // THE SILENT TOKEN SYNC ENGINE:
  //       // Force your custom authentication framework to verify cookies right away.
  //       // This decodes the full profile payload parameters into useAuth() immediately.
  //       setIsAuthModalVisible(false);

  //       setSuccessMessage(`Order placed in ${currentTier.toUpperCase()} Mode!`);
  //       setIsSuccessCompVisible(true);
  //       setCart({}); // Clean state wipe upon transaction completion
  //     }
  //   } catch (error) {
  //     console.error("Google Order dispatch communication error:", error);
  //     setErrorMessage(
  //       error?.response?.data?.message || "Failed to submit order. Please try again.",
  //     );
  //     setIsErrorCompVisible(true);
  //   } finally {
  //     setIsProcessOrderLoading(false);
  //   }
  // }

  async function executeGoogleOrderProcessingPipeline(googleAuthToken) {
    if (isProcessOrderLoading) return;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 1: Process Google Guest Identity Authentication First
      const authResponse = await axiosWithCredentials.post("/googleGuestAuth/googleGuestAuth", {
        googleToken: googleAuthToken,
      });

      // const { accessToken } = authResponse.data;
      const strictLocalToken = authResponse.data.accessToken;

      // Immediately flag that we are entering an intentional checkout sequence
      // setAuth({
      //   accessToken,
      //   isProfileComplete: true,
      //   hasPendingPrepaidOrder: true, // Intercepts AppNav routing to hit PayForTable screen!
      // });
      // setIsAuthModalVisible(false);

      console.log("Are we Here Yet");
      // STEP 2: Map and structure the item totals for payment initialization request setup
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;
        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          menuType: currentTier,
          //  totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
        };
      });

      console.log("finalOrderItem", finalOrderItems);

      // .reduce() loops over finalOrderItems, multiplying qty * price, adding it to a rolling sum
      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Order Total Amount:", paymentAmount);

      // if (navigation) {
      //   navigation.navigate("payForTable");
      // } else if (navigationRef?.isReady()) {
      //   // Fallback fallback pointer case reference alternative if passed globally
      //   navigationRef.navigate("payForTable");
      // }

      console.log("No Forced routing to payment flow triggered.");

      // return;
      //----Run step 3 before..-----//
      // STEP 3: Request the checkout intent payload token link from the backend
      // Since we set the new accessToken in auth state, your intercepted credential configuration hooks will attach it
      const checkoutSetup = await axiosWithCredentials.post(
        "/payments2/initialize-checkout",
        {
          tableId,
          showId: activeShowData?._id,
          items: finalOrderItems,
          tableAnonymity,
        },
        {
          headers: { Authorization: `Bearer ${strictLocalToken}` },
        },
      );

      if (checkoutSetup.data.status === "success") {
        const targetUrl = checkoutSetup.data.data.checkoutUrl;
        setAuth({
          accessToken: strictLocalToken,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        });

        console.log("Success or Failure Test");

        setIsAuthModalVisible(false);
        setCart({});

        // Redirect out to Monnify Web Gateway Interface
        // window.location.href = targetUrl;
      }
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message || "Failed to finalize pipeline. Verify inputs.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeAppleOrderProcessingPipeline(appleCredential) {
    if (isProcessOrderLoading) return;

    try {
      setIsProcessOrderLoading(true);

      // Extract identity token and raw user object (if present) from Apple credential response
      const { identityToken, user } = appleCredential;

      // STEP 1: Process Apple Guest Identity Authentication First
      const authResponse = await axiosWithCredentials.post("/appleGuestAuth/appleGuestAuth", {
        id_token: identityToken,
        rawUser: user, // Sent by Apple SDK on initial sign-in
      });

      const strictLocalToken = authResponse.data.accessToken;

      console.log("Apple Guest Auth Successful");

      // STEP 2: Map and structure the item totals for payment initialization request setup
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;
        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      const checkoutSetup = await axiosWithCredentials.post(
        "/payments2/initialize-checkout",
        {
          tableId,
          showId: activeShowData?._id,
          items: finalOrderItems,
          tableAnonymity,
        },
        {
          headers: { Authorization: `Bearer ${strictLocalToken}` },
        },
      );

      if (checkoutSetup.data.status === "success") {
        const targetUrl = checkoutSetup.data.data.checkoutUrl;

        setAuth({
          accessToken: strictLocalToken,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        });

        console.log("Apple Checkout Pipeline Completed Successfully");

        setIsAuthModalVisible(false);
        setCart({});

        // Redirect to Payment Gateway (e.g., Monnify)
        // window.location.href = targetUrl;
      }
    } catch (error) {
      console.error("Apple Order Pipeline Failure:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to finalize pipeline. Verify inputs.",
      );
      setIsProcessOrderLoading(false);
      setIsErrorCompVisible(true);
    }
    // finally {
    //   setIsProcessOrderLoading(false); //Because Apple stops isLoading and wastes time making user to click the button multiple times
    // }
  }

  //Mostly for users using phone number
  async function executeOrderProcessingPipeline() {
    //console.log("1. pipeline entered");
    if (isProcessOrderLoading) return;
    // 1. Structural safety validation
    //console.log("2. past loading guard");
    if (!tableId || Object.keys(cart).length === 0) {
      //console.log("3. BAILED - tableId:", tableId, "cart:", cart);

      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    //console.log("4. past cart/table guard - proceeding to request");

    try {
      // 2. Map items perfectly to match the backend embedded sub-document array rules
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId, // Maps to schema menuItemId
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
          menuType: currentTier, // ENUM: "regular" or "doings"
        };
      });

      // 3. Build order payload tailored for your table batch schema push
      // We send this as a new order batch object ready for an array update
      const newOrderPayload = {
        orderTotalAmount: totalPrice,
        status: "pending", // Schema default fallback setting
        items: finalOrderItems,
        phoneNumber: whatsappNumber,
        tableAnonymity,
      };

      //console.log("Transmitting transactional package to backend endpoint:", newOrderPayload);
      //console.log("Transmitting transmmut:", finalOrderItems);
      setIsProcessOrderLoading(true);
      // 4. Send network request to append the order to the virtual table
      // Assuming your endpoint updates a table, e.g., POST or PATCH to /tables/${tableId}/orders
      //Mostly Phone numbersBased
      const response = await axiosWithCredentials.post(
        `/createTableOrderPublic/createTableOrderPublic/${tableId}`,
        {
          ...newOrderPayload,
        },
      );

      //console.log("this here");

      if (response.status === 200 || response.status === 201) {
        const { accessToken, user, isProfileComplete } = response.data;

        console.log("AccessT", accessToken, "isProfileComp", isProfileComplete);

        setAuth({ accessToken, isProfileComplete });

        // Store profile traits and server configurations if returned in the response
        // if (guestUser) setUserInfo(guestUser);
        // if (activitySettings) setActivitySettings(activitySettings);
        // setTableData(tableData);

        setSuccessMessage(`Order placed in ${currentTier.toUpperCase()} Mode! Processing items.`);
        setIsSuccessCompVisible(true);
        setCart({}); // Flash clean state wipe upon completion
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  // //Mostly for topUps and LoggedIn Users - topups only happens by LoggedIn users
  // async function executeOrderProcessingPrivatePipeline() {
  //   //console.log("1. pipeline entered");
  //   if (isProcessOrderLoading) return;
  //   // 1. Structural safety validation
  //   //console.log("2. past loading guard");
  //   if (!tableId || Object.keys(cart).length === 0) {
  //     //console.log("3. BAILED - tableId:", tableId, "cart:", cart);

  //     setErrorMessage("Your cart is empty or the table context is missing.");
  //     setIsErrorCompVisible(true);
  //     return;
  //   }

  //   //console.log("4. past cart/table guard - proceeding to request");

  //   try {
  //     // 2. Map items perfectly to match the backend embedded sub-document array rules
  //     const finalOrderItems = Object.keys(cart).map((cartId) => {
  //       const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
  //       const targetPrice =
  //         currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

  //       return {
  //         menuItemId: cartId, // Maps to schema menuItemId
  //         name: findItem?.name || "Unknown Item",
  //         quantity: cart[cartId],
  //         unitPrice: targetPrice || 0,
  //         totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
  //         menuType: currentTier, // ENUM: "regular" or "doings"
  //       };
  //     });

  //     // 3. Build order payload tailored for your table batch schema push
  //     // We send this as a new order batch object ready for an array update
  //     const newOrderPayload = {
  //       orderTotalAmount: totalPrice,
  //       status: "pending", // Schema default fallback setting
  //       items: finalOrderItems,
  //       phoneNumber: whatsappNumber,
  //       tableAnonymity,
  //     };

  //     //console.log("Transmitting transactional package to backend endpoint:", newOrderPayload);
  //     //console.log("Transmitting transmmut:", finalOrderItems);
  //     setIsProcessOrderLoading(true);
  //     // 4. Send network request to append the order to the virtual table
  //     // Assuming your endpoint updates a table, e.g., POST or PATCH to /tables/${tableId}/orders
  //     //Note a new table and user is Logged In - TopUps
  //     const response = await axiosPrivate.post(`/createTableOrder/createTableOrder/${tableId}`, {
  //       ...newOrderPayload,
  //     });

  //     //console.log("this here");

  //     if (response.status === 200 || response.status === 201) {
  //       setSuccessMessage(`Order placed in ${currentTier.toUpperCase()} Mode! Processing items.`);
  //       setIsSuccessCompVisible(true);
  //       setCart({}); // Flash clean state wipe upon completion

  //       setAuth((prev) => ({
  //         ...prev,
  //         isProfileComplete: true,
  //         // if the response carries an updated token/user payload, fold it in too:
  //         // accessToken: response.data.accessToken ?? prev.accessToken,
  //       }));

  //       setTimeout(() => {
  //         // setIsSuccessCompVisible(false);
  //         navigation.reset({ index: 0, routes: [{ name: "main" }] });
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.error("Order dispatch communication error:", error);
  //     setErrorMessage(
  //       error?.response?.data?.message || "Failed to submit order. Please try again.",
  //     );
  //     setIsErrorCompVisible(true);
  //   } finally {
  //     setIsProcessOrderLoading(false);
  //   }
  // }

  async function executeOrderProcessingPrivatePipelineTopUp() {
    if (isProcessOrderLoading) return;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          // Optional tracking sub-properties depending on your server-side map parsing
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Private Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      // Utilizing axiosPrivate ensures current access credentials from context pass automatically
      const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout-topUp", {
        tableId,
        showId: activeShowData?._id,
        items: finalOrderItems,
        tableAnonymity,
        phoneNumber: whatsappNumber, // Folded in from local configuration input
      });

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally to pass state monitoring to PayForTable screen intercepts
        console.log("Teating hasPendingOrder", checkoutSetup.data?.hasPendingPrepaidOrder);
        sessionStorage.removeItem("is_topup_flow");
        setAuth((prev) => ({
          ...prev,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});

        // If you use an explicit modal/component wrapper configuration layer, hide it here:
        // setIsAuthModalVisible(false);
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  const allHaveImages =
    menuItems.length > 0 && menuItems.every((item) => item.image && item.image.trim() !== "");

  if (isProcessOrderLoading) {
    return (
      <View
        style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "#fff" }}
      >
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
        <Text style={{ marginTop: dynamicSpacing(15), fontFamily: "Sen-Bold", color: "#1A1A1A" }}>
          {/* Sending order to kitchen... */}
          {selectedPaymentType === "later"
            ? "Sending order to Bar & Kitchen..."
            : "Connecting to payment gateway..."}
        </Text>
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      {isLoading ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size="large" color={Colours.PRIMARY} />
        </View>
      ) : (
        // 🌟 WRAPPER VIEW: Ensures children flex and stack correctly
        <View style={styles.screenWrapper}>
          {/* 📌 FIXED TOP HEADER: Completely isolated from the scrolling list ecosystem */}
          <View style={styles.fixedHeader}>
            <TopHeaderComponent
              headerText={"Explore Menu"}
              hideScreen={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  // navigation.navigate("chooseFlex", { tableId });
                  navigation.navigate("main");
                }
              }}
            />
          </View>

          {/* DYNAMIC SCROLLER */}
          <View style={styles.scrollArea}>
            <FlatList
              data={menuItems}
              keyExtractor={(item) => item._id || item.id}
              showsVerticalScrollIndicator={false}
              // ❌ Removed stickyHeaderIndices={[0]} since the header is now truly fixed above the list
              contentContainerStyle={{
                paddingBottom: totalItems > 0 ? dynamicSpacing(140) : dynamicSpacing(40),
              }}
              // 🌟 CLEAN SCROLLABLE HEADER ELEMENTS
              ListHeaderComponent={
                <View
                  style={{ paddingHorizontal: dynamicSpacing(20), paddingTop: dynamicSpacing(10) }}
                >
                  {/* BRAND HERO CARD - Modern Dual/Single State */}
                  {isOngoingShow ? (
                    <View style={styles.brandHeroCard}>
                      {/* BADGE OVERLAY */}
                      <View style={styles.liveBadge}>
                        <View style={styles.liveDot} />
                        <Text style={styles.liveBadgeText}>ONGOING SHOW</Text>
                      </View>

                      {/* BRAND COMPARISON ROW */}
                      <View style={styles.collabRow}>
                        {/* PROMOTER BRAND */}
                        <View style={styles.brandCol}>
                          <Image
                            source={{
                              uri: activeShowData?.promoter?.image || "https://placehold.co/150",
                            }}
                            style={styles.collabImage}
                            contentFit="cover"
                            cachePolicy="disk"
                          />
                          <Text style={styles.collabNameTxt} numberOfLines={1}>
                            {activeShowData?.promoter?.brandName || "Promoter"}
                          </Text>
                        </View>

                        {/* MATCHUP DIVIDER */}
                        <View style={styles.dividerBadge}>
                          <Text style={styles.dividerTxt}>✕</Text>
                        </View>

                        {/* VENUE BRAND */}
                        <View style={styles.brandCol}>
                          <Image
                            source={{ uri: brandImage || "https://placehold.co/150" }}
                            style={styles.collabImage}
                            contentFit="cover"
                            cachePolicy="disk"
                          />
                          <Text style={styles.collabNameTxt} numberOfLines={1}>
                            {brandName || "Venue"}
                          </Text>
                        </View>
                      </View>

                      {/* SHOW CAPTION */}
                      {/* SHOW CAPTION */}
                      <View style={styles.showCaptionContainer}>
                        <View style={styles.showCaptionInnerWrapper}>
                          {/* Left Show Banner Image */}
                          <Image
                            source={{
                              uri:
                                activeShowData?.banner ||
                                activeShowData?.image ||
                                "https://placehold.co/100",
                            }}
                            style={styles.showBannerImage}
                            contentFit="cover"
                            cachePolicy="disk"
                          />

                          {/* Caption & Address Details */}
                          <View style={styles.showCaptionDetails}>
                            <Text style={styles.showCaptionTxt} numberOfLines={2}>
                              {activeShowData?.caption || "Live Event Information"}
                            </Text>
                            {brandAddress && (
                              <View style={styles.addressRow}>
                                <Ionicons
                                  name="location-sharp"
                                  size={dynamicSize(14)}
                                  color={Colours.PRIMARY || "#FF3B30"}
                                  style={{ marginRight: dynamicSpacing(4) }}
                                />
                                <Text style={styles.addressTxt} numberOfLines={1}>
                                  {brandAddress}
                                </Text>
                              </View>
                            )}
                          </View>
                        </View>
                      </View>
                    </View>
                  ) : (
                    /* STANDARD BRAND CARD */
                    <View style={styles.brandHeroCard}>
                      <View style={styles.standardHeroRow}>
                        <Image
                          source={{ uri: brandImage || "https://placehold.co/150" }}
                          style={styles.brandImage}
                          contentFit="cover"
                          cachePolicy="disk"
                        />
                        <View style={styles.brandMetaInfo}>
                          <Text style={styles.nameTxt} numberOfLines={1}>
                            {brandName || "Company Title"}
                          </Text>
                          <Text style={styles.emailTxt} numberOfLines={2}>
                            {brandAddress || "Location Details Not Set"}
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}
                  <View style={styles.flexSpendContainer}>
                    <View style={styles.flexHeaderRow}>
                      <Text style={styles.flexSpendHeading}>{tableDataUpdate?.tableName}</Text>
                      <View style={styles.activeBadge}>
                        <Text style={styles.activeBadgeText}>{tableDataUpdate?.tableNumber}</Text>
                      </View>
                    </View>
                  </View>

                  {/* --- FLEX SPEND MODE TOGGLE CONTROL --- */}
                  {/* --- MODERN FLEX SPEND SELECTOR --- */}

                  {/* <View style={styles.flexSpendContainer}>
                    <View style={styles.flexHeaderRow}>
                      <Text style={styles.flexSpendHeading}>Your Spend Mode</Text>
                      <View
                        style={[
                          styles.activeBadge,
                          selectedFlexTier === "doings"
                            ? { backgroundColor: Colours.PRIMARY_LIGHTER }
                            : { backgroundColor: Colours.LIGHTEST },
                        ]}
                      >
                        <Text
                          style={[
                            styles.activeBadgeText,
                            selectedFlexTier === "doings"
                              ? { color: Colours.PRIMARY }
                              : { color: Colours.DARKLIGHTGRAY },
                          ]}
                        >
                          {selectedFlexTier === "doings" ? "DOINGS MODE" : "REGULAR MODE"}
                        </Text>
                      </View>
                    </View>

                    {selectedFlexTier === "doings" ? (
                      <View style={styles.doingsDescriptionBox}>
                        <DoingsModeBadge size={dynamicSize(15)} color="#D4AF37" />
                        <Text style={styles.doingsDescriptionText}>
                          Spending in Doings mode gives your table the Doings badge and places your
                          table at the very top of the Doings trend.
                        </Text>
                      </View>
                    ) : (
                      <View style={styles.regularDescriptionBox}>
                        <Ionicons
                          name="information-circle-outline"
                          size={dynamicSize(16)}
                          color={Colours.DARKLIGHTGRAY}
                        />
                        <Text style={styles.regularDescriptionText}>
                          Standard menu items and rates applied to your checkout basket.
                        </Text>
                      </View>
                    )}
                  </View> */}

                  {/* MODERN SEGMENTED CONTROLS */}

                  {/* <View style={styles.segmentedControl}>
                      <TouchableOpacity
                        activeOpacity={0.8}
                        style={[
                          styles.segmentButton,
                          selectedFlexTier === "regular" && styles.segmentButtonActive,
                        ]}
                        onPress={() => setSelectedFlexTier("regular")}
                      >
                        <Text
                          style={[
                            styles.segmentText,
                            selectedFlexTier === "regular" && styles.segmentTextActiveRegular,
                          ]}
                        >
                          Regular
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        activeOpacity={0.8}
                        style={[
                          styles.segmentButton,
                          selectedFlexTier === "doings" && styles.segmentButtonActiveDoings,
                        ]}
                        onPress={() => setSelectedFlexTier("doings")}
                      >
                        <Text
                          style={[
                            styles.segmentText,
                            selectedFlexTier === "doings" && styles.segmentTextActiveDoings,
                          ]}
                        >
                          Doings
                        </Text>
                      </TouchableOpacity>
                    </View> */}

                  {/* DYNAMIC CALLOUT CARDS */}

                  {/* <View style={styles.brandHeroCard}>
                    <Image
                      source={{ uri: brandImage || "https://placehold.co/150" }}
                      style={styles.brandImage}
                      contentFit="cover"
                      cachePolicy="disk"
                    />
                    <View style={styles.brandMetaInfo}>
                      <Text style={styles.nameTxt} numberOfLines={1}>
                        {brandName || "Company Title"}
                      </Text>
                      <Text style={styles.emailTxt} numberOfLines={2}>
                        {brandAddress || "Location Details Not Set"}
                      </Text>
                    </View>
                  </View> */}

                  {/* CATEGORY TABS - Will scroll away naturally */}
                  <View style={{ marginBottom: dynamicSpacing(15) }}>
                    <FlatList
                      data={publicCategories}
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      keyExtractor={(item) => item}
                      renderItem={({ item }) => {
                        const isActive = selectedCategory === item;
                        return (
                          <TouchableOpacity
                            onPress={() => setSelectedCategory(item)}
                            style={[styles.categoryTab, isActive && styles.activeCategoryTab]}
                          >
                            <Text
                              style={[
                                styles.categoryTabText,
                                isActive && styles.activeCategoryTabText,
                              ]}
                            >
                              {item}
                            </Text>
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                </View>
              }
              ListEmptyComponent={() => (
                <View style={{ alignItems: "center", marginTop: 40 }}>
                  <Text style={{ color: "#8E8E93" }}>
                    No available items found in this section.
                  </Text>
                </View>
              )}
              renderItem={({ item }) => {
                const currentId = item._id || item.id;
                const quantity = cart[currentId] || 0;
                // const activePriceDisplay =
                //   currentTier === "doings" ? item.doingsPrice : item.regularPrice;
                // Re-bind pricing tier dynamically based on active selectedFlexTier
                const activePriceDisplay =
                  selectedFlexTier === "doings" ? item.doingsPrice : item.regularPrice;

                // 1. TEXT-ONLY COMPACT LAYOUT (If missing images)
                if (!allHaveImages) {
                  return (
                    <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
                      <View style={styles.menuItemDetails}>
                        <Text style={styles.menuItemName} numberOfLines={2}>
                          {item.name}
                        </Text>
                        {item.description && (
                          <Text
                            style={{
                              fontSize: dynamicFontSize(12),
                              color: "#666666",
                              marginTop: dynamicSpacing(2),
                            }}
                            numberOfLines={2}
                          >
                            {item.description}
                          </Text>
                        )}
                        <Text style={styles.menuItemPrice}>
                          ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                        </Text>
                      </View>

                      {/* COUNTER CONTROLS */}
                      <View style={styles.counterContainer}>
                        {quantity > 0 && (
                          <>
                            <TouchableOpacity
                              onPress={() => handleUpdateQuantity(currentId, "subtract")}
                              style={styles.counterBtn}
                            >
                              <Ionicons
                                name="remove"
                                size={dynamicSize(16)}
                                color={Colours.PRIMARY}
                              />
                            </TouchableOpacity>
                            <Text style={styles.counterText}>{quantity}</Text>
                          </>
                        )}
                        <TouchableOpacity
                          onPress={() => handleUpdateQuantity(currentId, "add")}
                          style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                        >
                          <Ionicons name="add" size={dynamicSize(16)} color="white" />
                        </TouchableOpacity>
                      </View>
                    </View>
                  );
                }

                return (
                  <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
                    <Image
                      source={{ uri: item.image || brandImage }}
                      style={styles.menuItemImage}
                      contentFit="cover"
                    />
                    <View style={styles.menuItemDetails}>
                      <Text style={styles.menuItemName} numberOfLines={2}>
                        {item.name}
                      </Text>
                      <Text style={styles.menuItemPrice}>
                        ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                      </Text>
                    </View>
                    <View style={styles.counterContainer}>
                      {quantity > 0 && (
                        <>
                          <TouchableOpacity
                            onPress={() => handleUpdateQuantity(currentId, "subtract")}
                            style={styles.counterBtn}
                          >
                            <Ionicons
                              name="remove"
                              size={dynamicSize(16)}
                              color={Colours.PRIMARY}
                            />
                          </TouchableOpacity>
                          <Text style={styles.counterText}>{quantity}</Text>
                        </>
                      )}
                      <TouchableOpacity
                        onPress={() => handleUpdateQuantity(currentId, "add")}
                        style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                      >
                        <Ionicons name="add" size={dynamicSize(16)} color="white" />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>

          {/* 📌 FIXED CHECKOUT DRAWER: Placed completely outside the FlatList layout tree */}
          {totalItems > 0 && (
            <View
              style={[
                styles.checkoutStickyContainer,
                {
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "#ffffff",
                  borderTopWidth: 1,
                  borderTopColor: "#EAEAEA",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: -3 },
                  shadowOpacity: 0.1,
                  shadowRadius: 5,
                  elevation: 10,
                },
              ]}
            >
              {/* 🌟 EXPANDABLE BASKET DETAILS CONTAINER */}
              {isCartExpanded && (
                <View
                  style={{
                    padding: dynamicSpacing(20),
                    borderBottomWidth: 1,
                    borderBottomColor: "#F5F5F7",
                    maxHeight: dynamicSize(250),
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: dynamicSpacing(10),
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "Sen-Bold",
                        fontSize: dynamicFontSize(16),
                        color: "#1A1A1A",
                      }}
                    >
                      Review Selected Items ({selectedFlexTier.toUpperCase()})
                    </Text>
                    <TouchableOpacity onPress={() => setIsCartExpanded(false)}>
                      <Ionicons name="chevron-down" size={dynamicSize(20)} color="#8E8E93" />
                    </TouchableOpacity>
                  </View>

                  <ScrollView showsVerticalScrollIndicator={true} nestedScrollEnabled={true}>
                    {Object.keys(cart).map((cartId) => {
                      const itemMatch = menuItems.find((m) => (m._id || m.id) === cartId);
                      const itemQty = cart[cartId];
                      if (itemQty <= 0 || !itemMatch) return null;

                      // const itemPrice =
                      //   currentTier === "doings" ? itemMatch.doingsPrice : itemMatch.regularPrice;
                      const itemPrice =
                        selectedFlexTier === "doings"
                          ? itemMatch.doingsPrice
                          : itemMatch.regularPrice;

                      return (
                        <View
                          key={cartId}
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingVertical: dynamicSpacing(8),
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: dynamicSpacing(8),
                              flex: 1,
                              paddingRight: dynamicSpacing(10),
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Sen-Bold",
                                color: Colours.PRIMARY,
                                fontSize: dynamicFontSize(14),
                              }}
                            >
                              {itemQty}x
                            </Text>
                            <Text
                              style={{ color: "#333", fontSize: dynamicFontSize(14) }}
                              numberOfLines={1}
                            >
                              {itemMatch.name}
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Sen-Bold",
                              color: "#1A1A1A",
                              fontSize: dynamicFontSize(14),
                            }}
                          >
                            ₦{((itemPrice || 0) * itemQty).toLocaleString()}
                          </Text>
                        </View>
                      );
                    })}
                  </ScrollView>
                </View>
              )}

              {/* CORE ACTION SUB-BAR */}
              <View style={styles.priceRowContainer}>
                {/* Clicking this side toggles the itemized scroll overlay drawer */}
                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => setIsCartExpanded(!isCartExpanded)}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: dynamicSpacing(6),
                  }}
                >
                  <View>
                    <Text style={styles.basketCountText}>
                      {totalItems} {totalItems === 1 ? "item" : "items"} selected
                    </Text>
                    <Text style={styles.basketTotalValue}>₦{totalPrice.toLocaleString()}</Text>
                  </View>
                  <Ionicons
                    name={isCartExpanded ? "chevron-down" : "chevron-up"}
                    size={dynamicSize(16)}
                    color={Colours.PRIMARY}
                    style={{ marginTop: dynamicSpacing(12) }}
                  />
                </TouchableOpacity>

                <TouchableOpacity style={styles.proceedBtn} onPress={handlePlaceOrder}>
                  {isProcessOrderLoading ? (
                    <ActivityIndicator size="large" color="white" />
                  ) : (
                    <Text style={styles.proceedBtnText}>Place Order</Text>
                  )}
                  <MaterialCommunityIcons
                    name="silverware-fork-knife"
                    size={dynamicSize(18)}
                    color="white"
                  />
                </TouchableOpacity>
              </View>
            </View>
          )}
        </View>
      )}

      {/* ── PAYSTACK SYSTEM LEVEL INTEGRATION NOTICE ALERT OVERLAY ── */}
      <Modal visible={showChoosePayment} transparent={true} animationType="fade">
        <View style={styles.alertModalCenteredBackdrop}>
          <View style={styles.alertModalContainerBox}>
            {/* CLOSE BUTTON */}
            <TouchableOpacity
              style={styles.alertModalCloseButton}
              onPress={() => setShowChoosePayment(false)}
            >
              <Ionicons name="close" size={dynamicSize(18)} color="#888" />
            </TouchableOpacity>

            <View style={styles.alertIconHeaderContainer}>
              <MaterialCommunityIcons name="shield-check" size={32} color={Colours.PRIMARY} />
            </View>

            <Text style={styles.alertModalHeading}>Confirm Bill Total</Text>

            <Text style={styles.alertModalMessage}>
              {/* Pay now with transfer or pay later if you use an ATM card, your total bill is {"\n"} */}
              Pay now with transfer{" "}
              <Text style={{ fontStyle: "italic", color: Colours.PRIMARY }}>
                powered by moniepoint
              </Text>
              , your total bill.{"\n"}
              Pay exactly{"\n"}
              <Text style={styles.alertModalAmountHighlight}>
                ₦{totalPrice ? totalPrice.toLocaleString() : "0"}
              </Text>
            </Text>

            {/* <Text style={styles.alertModalMessage}>
              You can choose to pay now or after the fun is over, your total sum is {"\n"}
              <Text style={styles.alertModalAmountHighlight}>
                ₦{totalPrice ? totalPrice.toLocaleString() : "0"}
              </Text>
            </Text> */}

            {/* BUTTON CONTAINER - Stacked for better readability with longer text */}
            <View style={styles.alertModalButtonWrapper}>
              <TouchableOpacity
                style={styles.alertModalOkButton}
                onPress={() => {
                  // console.log("NewTableData", tableDataUpdate);

                  setShowChoosePayment(false);
                  handlePaymentChoice("now");
                }}
              >
                {/* <Text style={styles.alertModalOkText}>Pay now with transfer</Text> */}
                <Text style={styles.alertModalOkText}>Pay</Text>
              </TouchableOpacity>
              {/* 
              <TouchableOpacity
                style={styles.alertModalCancelButton}
                onPress={() => {
                  setShowChoosePayment(false);
                  handlePaymentChoice("later");
                }}
              >
                <Text style={styles.alertModalCancelText}>Pay later with ATM card</Text>
              </TouchableOpacity> */}
            </View>
          </View>
        </View>
      </Modal>

      {/* WAITER SELECTION MODAL */}
      <Modal visible={showSelectWaiter} transparent={true} animationType="fade">
        <View style={styles.alertModalCenteredBackdrop}>
          <View style={styles.alertModalContainerBox}>
            {/* CLOSE BUTTON */}
            <TouchableOpacity
              style={styles.alertModalCloseButton}
              onPress={() => setShowSelectWaiter(false)}
            >
              <Ionicons name="close" size={dynamicSize(18)} color="#888" />
            </TouchableOpacity>

            <View style={styles.alertIconHeaderContainer}>
              <MaterialCommunityIcons
                name="account-search-outline"
                size={32}
                color={Colours.PRIMARY}
              />
            </View>

            <Text style={styles.alertModalHeading}>Select Your Waiter</Text>
            <Text style={styles.waiterSubtitleText}>
              {/* Select who is attending to {tableDataUpdate?.tableName || "your table"} to continue. */}
              Select who is attending to your table to continue.
            </Text>

            {/* WAITER LIST */}
            {isLoadingWaiters ? (
              <View style={styles.waiterLoadingContainer}>
                <ActivityIndicator size="small" color={Colours.PRIMARY} />
                <Text style={styles.waiterLoadingText}>Fetching team...</Text>
              </View>
            ) : (
              <ScrollView style={styles.waiterListScroll} showsVerticalScrollIndicator={false}>
                {brandWaiters.map((waiter) => {
                  // Determine active selection using current table state or manually selected waiter
                  const currentActiveWaiterID = tableDataUpdate?.waiterID || selectedWaiter?._id;
                  const isSelected = currentActiveWaiterID === waiter._id;

                  return (
                    <TouchableOpacity
                      key={waiter._id}
                      style={[styles.waiterSelectItem, isSelected && styles.waiterSelectItemActive]}
                      onPress={() => handleSelectWaiter(waiter)}
                    >
                      {/* Waiter Sequential Number (e.g., W1, W2) */}
                      <View style={[styles.waiterBadge, isSelected && styles.waiterBadgeActive]}>
                        <Text
                          style={[
                            styles.waiterBadgeText,
                            isSelected && styles.waiterBadgeTextActive,
                          ]}
                        >
                          {waiter.waiterNumber || "W"}
                        </Text>
                      </View>

                      {/* Waiter Details */}
                      <View style={styles.menuItemDetails}>
                        <Text style={styles.menuItemName}>
                          {waiter.waiterName || waiter.userID?.username || "Staff Member"}
                        </Text>
                        <Text style={styles.waiterBadgeSubtext}>Waiter</Text>
                      </View>

                      <MaterialCommunityIcons
                        name={isSelected ? "radiobox-marked" : "radiobox-blank"}
                        size={dynamicSize(20)}
                        color={isSelected ? Colours.PRIMARY : "#BDBDBD"}
                      />
                    </TouchableOpacity>
                  );
                })}
              </ScrollView>
            )}
          </View>
        </View>
      </Modal>

      {/* 🔒 AUTHENTICATION CHECK BOTTOM SHEET MODAL */}
      <Modal
        visible={isAuthModalVisible}
        transparent
        animationType="slide"
        onRequestClose={() => setIsAuthModalVisible(false)}
      >
        {/* Semi-transparent backdrop blur wrapper */}
        <View
          style={{ flex: 1, backgroundColor: "rgba(0, 0, 0, 0.5)", justifyContent: "flex-end" }}
        >
          {/* 🌟 Backdrop Dismiss Target: Covers only the empty top area */}
          <TouchableOpacity
            style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            activeOpacity={1}
            onPress={() => setIsAuthModalVisible(false)}
          />

          {/* 🌟 FIXED SHEET CONTAINER PANEL: Switched to Pressable with event isolation */}
          <Pressable
            onPress={(e) => e.stopPropagation()} //  Prevents click event leakage from closing the modal
            style={{
              backgroundColor: "white",
              borderTopLeftRadius: dynamicSize(24),
              borderTopRightRadius: dynamicSize(24),
              paddingHorizontal: dynamicSpacing(24),
              paddingTop: dynamicSpacing(16),
              paddingBottom: dynamicSpacing(40),
              maxHeight: "80%",
              width: "100%",
              zIndex: 10,
            }}
          >
            {/* Top Drag Indicator Notch */}
            <View
              style={{
                width: 40,
                height: 5,
                backgroundColor: "#E5E5EA",
                borderRadius: 3,
                alignSelf: "center",
                marginBottom: dynamicSpacing(20),
              }}
            />
            <Text
              style={{
                fontFamily: "Sen-Bold",
                fontSize: dynamicFontSize(20),
                color: "#1A1A1A",
                textAlign: "center",
                marginBottom: dynamicSpacing(6),
              }}
            >
              {/* Almost done pleeease */}
              Important for payments
            </Text>
            <Text
              style={{
                fontSize: dynamicFontSize(14),
                color: "#666",
                textAlign: "center",
                marginBottom: dynamicSpacing(24),
              }}
            >
              Your Identity will help us process your orders and payments effectively, thank you.
              {/* To send your order to the kitchen and save your digital receipt, quickly secure your
              profile */}
            </Text>
            {/* OAUTH SSO BUTTON CONTAINER CLUSTER */}
            <View style={{ gap: dynamicSpacing(12), marginBottom: dynamicSpacing(24) }}>
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  borderWidth: 1,
                  borderColor: "#E5E5EA",
                  borderRadius: dynamicSize(12),
                  paddingVertical: dynamicSpacing(14),
                }}
                onPress={() => promptAsync({ useProxy: true })}
              >
                <Ionicons name="logo-google" size={20} color="#EA4335" />
                {/* <Image
                  source={{
                    uri: "https://developers.google.com/identity/images/g-logo.png",
                  }}
                  style={styles.googleIcon}
                /> */}
                <Text
                  style={{
                    fontFamily: "Sen-Bold",
                    fontSize: dynamicFontSize(15),
                    color: "#1A1A1A",
                  }}
                >
                  Continue with Google
                </Text>
              </TouchableOpacity>

              <AppleSignin
                authOptions={{
                  // clientId: "com.mexa.pwa", // Your registered Apple Services
                  clientId: "com.mexxzia.pwa",
                  scope: "email name",
                  redirectURI: "https://app.getmeeza.com/",
                  // redirectURI: "https://getmeeza.com/prollix/appleAuth/appleAuth", // Must match Apple Developer Portal
                  usePopup: true, // Prevents page reload so cart state remains intact
                }}
                onSuccess={handleAppleSuccess}
                onError={handleAppleFailure}
                render={(props) => (
                  <TouchableOpacity
                    // disabled={true}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 10,
                      backgroundColor: "#000",
                      borderRadius: dynamicSize(12),
                      paddingVertical: dynamicSpacing(14),
                    }}
                    onPress={props.onClick}
                  >
                    <Ionicons name="logo-apple" size={20} color="white" />
                    <Text
                      style={{
                        fontFamily: "Sen-Bold",
                        fontSize: dynamicFontSize(15),
                        color: "white",
                      }}
                    >
                      Continue with Apple
                    </Text>
                  </TouchableOpacity>
                )}
              />
            </View>

            {/* STYLED DIVIDER SECTION */}
          </Pressable>
        </View>
      </Modal>

      {/* MODAL OVERLAY PORTAL */}
      <Modal visible={isErrorCompVisible} transparent animationType="fade">
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setCart({});
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setCart({});
            setIsSuccessCompVisible(false);
            handleBackNavigation();
          }}
        />
      </Modal>
    </SafeAreaView>
  );
};

export default BrandMenuScreen;

// --- STYLING PATTERNS ARCHITECTURE ---
const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "#F9F9FA",
    // On web, SafeAreaView doesn't constrain height by default
    ...(Platform.OS === "web" && {
      height: "100vh",
      overflow: "hidden",
    }),
  },
  scrollArea: {
    flex: 1,
    overflow: "hidden",
  },

  // Re-used identical structural brand card configurations
  brandHeroCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(16),
    marginBottom: dynamicSpacing(20),
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
  },
  brandImage: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12),
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },
  emailTxt: {
    color: "#666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(16),
  },
  screenWrapper: {
    flex: 1,
    overflow: "hidden",
  },
  fixedHeader: {
    backgroundColor: "#fff",
    zIndex: 1000,
  },
  googleIcon: {
    width: dynamicSize(20),
    height: dynamicSize(20),
    marginRight: dynamicSpacing(12),
  },
  // Menu Category items
  categoryTab: {
    paddingHorizontal: dynamicSpacing(16),
    paddingVertical: dynamicSpacing(8),
    borderRadius: dynamicSize(20),
    backgroundColor: "#EBEBEF",
    marginRight: dynamicSpacing(10),
  },
  activeCategoryTab: {
    backgroundColor: Colours.PRIMARY,
  },
  categoryTabText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(13),
    color: "#555",
  },
  activeCategoryTabText: {
    color: "white",
  },

  // Menu List cards
  menuItemCard: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: dynamicSpacing(12),
    borderRadius: dynamicSize(14),
    alignItems: "center",
    marginBottom: dynamicSpacing(12),
    borderWidth: 1,
    borderColor: "#F0F0F2",
  },
  menuItemImage: {
    width: dynamicSize(65),
    height: dynamicSize(65),
    borderRadius: dynamicSize(10),
    backgroundColor: "#F5F5F7",
  },
  menuItemDetails: {
    flex: 1,
    marginLeft: dynamicSpacing(12),
    paddingRight: dynamicSpacing(8),
  },
  menuItemName: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    marginBottom: dynamicSpacing(4),
  },
  menuItemPrice: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: Colours.PRIMARY,
  },

  // Counter Elements
  counterContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F5F5F7",
    borderRadius: dynamicSize(20),
    padding: dynamicSpacing(4),
    gap: dynamicSpacing(8),
  },
  counterBtn: {
    width: dynamicSize(28),
    height: dynamicSize(28),
    borderRadius: dynamicSize(14),
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    elevation: 1,
  },
  counterText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    minWidth: dynamicSpacing(16),
    textAlign: "center",
  },

  // Footer Placement Panel
  checkoutStickyContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    paddingHorizontal: dynamicSpacing(20),
    paddingTop: dynamicSpacing(15),
    paddingBottom: Platform.OS === "ios" ? dynamicSpacing(35) : dynamicSpacing(20),
    borderTopLeftRadius: dynamicSize(20),
    borderTopRightRadius: dynamicSize(20),
    elevation: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    zIndex: 1000,
  },
  priceRowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  basketCountText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: "gray",
  },
  basketTotalValue: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(22),
    color: "#222",
  },
  proceedBtn: {
    backgroundColor: Colours.PRIMARY,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(24),
    height: dynamicSize(50),
    borderRadius: dynamicSize(14),
    gap: dynamicSpacing(8),
  },
  proceedBtnText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
  },

  /* ── CUSTOM PAYSTACK NOTICE POPUP STYLES ── */
  alertModalCenteredBackdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  alertModalContainerBox: {
    width: "100%",
    maxWidth: 320,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 24,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
    position: "relative",
  },
  alertModalCloseButton: {
    position: "absolute",
    top: 14,
    right: 14,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: "#F5F5F5",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
  alertIconHeaderContainer: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#FFF4F2",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  alertModalHeading: {
    fontFamily: "Sen-Bold",
    fontSize: 18,
    color: "#1A1A1A",
    marginBottom: 8,
    textAlign: "center",
  },
  alertModalMessage: {
    fontFamily: "Sen-Regular",
    fontSize: 14,
    color: "#555",
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 24,
  },
  alertModalAmountHighlight: {
    fontFamily: "Sen-Bold",
    fontSize: 20,
    color: Colours.PRIMARY,
  },
  // alertModalButtonWrapper: {
  //   flexDirection: "row",
  //   width: "100%",
  //   gap: 12,
  // },
  // alertModalCancelButton: {
  //   flex: 1,
  //   paddingVertical: 12,
  //   borderRadius: 10,
  //   backgroundColor: "#F5F5F5",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  // alertModalCancelText: {
  //   fontFamily: "Sen-Bold",
  //   fontSize: 14,
  //   color: "#666",
  // },
  // alertModalOkButton: {
  //   flex: 1,
  //   paddingVertical: 12,
  //   borderRadius: 10,
  //   backgroundColor: Colours.PRIMARY,
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  // alertModalOkText: {
  //   fontFamily: "Sen-Bold",
  //   fontSize: 14,
  //   color: "white",
  // },

  alertModalButtonWrapper: {
    flexDirection: "column", // Stacked vertically to prevent text truncation
    width: "100%",
    gap: 10,
  },
  alertModalCancelButton: {
    width: "100%",
    paddingVertical: 14,
    borderRadius: 10,
    backgroundColor: "#F5F5F5",
    alignItems: "center",
    justify: "center",
  },
  alertModalCancelText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "#666",
    textAlign: "center",
  },
  alertModalOkButton: {
    width: "100%",
    paddingVertical: 14,
    borderRadius: 10,
    backgroundColor: Colours.PRIMARY,
    alignItems: "center",
    justify: "center",
  },
  alertModalOkText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "white",
    textAlign: "center",
  },

  brandHeroCard: {
    backgroundColor: "#FFFFFF",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(20),
    marginBottom: dynamicSpacing(20),
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.03)",
    position: "relative",
    overflow: "hidden",
  },

  // Standard Card Layout
  standardHeroRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  brandImage: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(14),
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },
  emailTxt: {
    color: "#666666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(16),
    marginTop: dynamicSpacing(2),
  },

  // Live Show Layout
  liveBadge: {
    position: "absolute",
    top: dynamicSpacing(12),
    right: dynamicSpacing(14),
    backgroundColor: "#FFF0F0",
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(20),
    flexDirection: "row",
    alignItems: "center",
  },
  liveDot: {
    width: dynamicSize(6),
    height: dynamicSize(6),
    borderRadius: dynamicSize(3),
    backgroundColor: "#FF3B30",
    marginRight: dynamicSpacing(6),
  },
  liveBadgeText: {
    color: "#FF3B30",
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Bold",
    letterSpacing: 0.5,
  },
  collabRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: dynamicSpacing(12),
    paddingHorizontal: dynamicSpacing(10),
  },
  brandCol: {
    alignItems: "center",
    flex: 1,
  },
  collabImage: {
    width: dynamicSize(54),
    height: dynamicSize(54),
    borderRadius: dynamicSize(27),
    backgroundColor: "#F5F5F7",
    borderWidth: 1,
    borderColor: "#EFEFEF",
  },
  collabNameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
    marginTop: dynamicSpacing(6),
    textAlign: "center",
  },
  dividerBadge: {
    width: dynamicSize(28),
    height: dynamicSize(28),
    borderRadius: dynamicSize(14),
    backgroundColor: "#F4F4F6",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: dynamicSpacing(8),
  },
  dividerTxt: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Bold",
    color: "#8E8E93",
  },
  // showCaptionContainer: {
  //   marginTop: dynamicSpacing(14),
  //   paddingTop: dynamicSpacing(12),
  //   borderTopWidth: 1,
  //   borderTopColor: "#F2F2F7",
  //   alignItems: "center",
  // },
  showCaptionContainer: {
    marginTop: dynamicSpacing(14),
    paddingTop: dynamicSpacing(12),
    borderTopWidth: 1,
    borderTopColor: "#F2F2F7",
    alignItems: "center", // Center the inner wrapper within the card
    justifyContent: "center",
  },
  showCaptionInnerWrapper: {
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "90%", // Prevents pushing against container edges while keeping content centered
  },
  showBannerImage: {
    width: dynamicSize(44),
    height: dynamicSize(44),
    borderRadius: dynamicSize(8),
    backgroundColor: "#F5F5F7",
    marginRight: dynamicSpacing(8), // Reduced spacing to bring them close together
  },
  showCaptionDetails: {
    flexShrink: 1, // Shrinks smoothly while preserving close spacing
    justifyContent: "center",
  },
  showCaptionTxt: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY || "#111111",
    lineHeight: dynamicFontSize(18),
  },
  addressRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: dynamicSpacing(4),
  },
  addressTxt: {
    color: "#666666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    flexShrink: 1,
  },

  flexSpendContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: dynamicSize(18),
    padding: dynamicSpacing(16),
    marginBottom: dynamicSpacing(20),
    borderWidth: 1,
    borderColor: Colours.LIGHTGRAY,
    // Smooth modern ambient card shadow
    shadowColor: Colours.BLACK,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.04,
    shadowRadius: 10,
    elevation: 3,
  },
  flexHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: dynamicSpacing(12),
  },
  flexSpendHeading: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: Colours.DARKGRAY,
    letterSpacing: -0.2,
  },
  activeBadge: {
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(20),
    color: Colours.PRIMARY,
  },
  activeBadgeText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(20),
    color: Colours.PRIMARY,
    letterSpacing: 0.5,
  },
  segmentedControl: {
    flexDirection: "row",
    backgroundColor: Colours.LIGHTEST,
    borderRadius: dynamicSize(12),
    padding: dynamicSpacing(4),
    borderWidth: 1,
    borderColor: Colours.LIGHTGRAY,
  },
  segmentButton: {
    flex: 1,
    paddingVertical: dynamicSpacing(10),
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(8),
  },
  segmentButtonActive: {
    backgroundColor: "#FFFFFF",
    shadowColor: Colours.BLACK,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  segmentButtonActiveDoings: {
    backgroundColor: Colours.PRIMARY,
    shadowColor: Colours.PRIMARY,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 4,
  },
  segmentText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
  },
  segmentTextActiveRegular: {
    color: Colours.DARKGRAY,
  },
  segmentTextActiveDoings: {
    color: "#FFFFFF",
  },
  doingsDescriptionBox: {
    flexDirection: "row",
    alignItems: "flex-start",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(12),
    borderRadius: dynamicSize(10),
    marginTop: dynamicSpacing(12),
    gap: dynamicSpacing(8),
  },
  doingsDescriptionText: {
    flex: 1,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: Colours.DARKGRAY,
    lineHeight: dynamicFontSize(17),
  },
  regularDescriptionBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colours.LIGHTEST,
    padding: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    marginTop: dynamicSpacing(12),
    gap: dynamicSpacing(8),
  },
  regularDescriptionText: {
    flex: 1,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: Colours.DARKLIGHTGRAY,
    lineHeight: dynamicFontSize(16),
  },

  /**WAITER MODAL STYLES */
  waiterSubtitleText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    textAlign: "center",
    marginBottom: dynamicSpacing(14),
  },
  waiterListScroll: {
    maxHeight: dynamicSize(220),
    width: "100%",
    marginVertical: dynamicSpacing(8),
  },
  waiterSelectItem: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colours.LIGHTEST,
    borderRadius: dynamicSize(12),
    padding: dynamicSpacing(10),
    marginBottom: dynamicSpacing(8),
    borderWidth: 1,
    borderColor: Colours.LIGHTGRAY,
  },
  waiterSelectItemActive: {
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderColor: Colours.PRIMARY,
  },
  waiterBadge: {
    width: dynamicSize(38),
    height: dynamicSize(38),
    borderRadius: dynamicSize(19),
    backgroundColor: Colours.LIGHTGRAY,
    justifyContent: "center",
    alignItems: "center",
  },
  waiterBadgeActive: {
    backgroundColor: Colours.PRIMARY,
  },
  waiterBadgeText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: Colours.PRIMARY,
  },
  waiterBadgeTextActive: {
    color: "#FFFFFF",
  },
  waiterBadgeSubtext: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(11),
    color: Colours.DARKLIGHTGRAY,
  },
  waiterLoadingContainer: {
    paddingVertical: dynamicSpacing(20),
    alignItems: "center",
  },
  waiterLoadingText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: Colours.DARKLIGHTGRAY,
    marginTop: dynamicSpacing(6),
  },
});
